import moment from "moment";
import { User } from "src/app/core/models/auth.models";
import { ProjectRequestModel } from "../../project-request/models/project-request.model";
import { ProjectModel } from "../../projects/models/project.model";
import { AbsenceTypeModel } from "./absence-type.model";

export enum AbsenceStatus {
    INSERTED = 'INSERTED',
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REFUSED = 'REFUSED',
    JUSTIFIED = 'JUSTIFIED'
}

export class AbsenceModel {
    public id: number;

    public startDate: Date | string;
    public endDate: Date | string;

    public duration: number;
    public status: AbsenceStatus;
    public observation: string;
    public decisionDate: Date;

    public uploadedFiles: any[];

    public colaboratorId: number | null;
    public absenceTypeId: number | null;
    public colaboratorDecisionId: number | null;

    public colaborator: any | null;
    public absenceType: AbsenceTypeModel | null;
    public colaboratorDecision: any | null;

    public createdAt: Date;
    public updatedAt: Date;

    constructor($obj?: any) {
        this.id = $obj ? $obj.id : '#new' + moment().valueOf();

        this.startDate = $obj && $obj.startDate ? moment($obj.startDate).utc().toDate() : new Date();
        this.endDate = $obj && $obj.endDate ? moment($obj.endDate).utc().toDate() : new Date();

        this.duration = $obj && $obj.duration ? $obj.duration : '';
        this.status = $obj && $obj.status ? $obj.status : AbsenceStatus.INSERTED;
        this.observation = $obj && $obj.observation ? $obj.observation : '';
        //this.decisionDate = $obj && $obj.decisionDate ? new Date($obj.decisionDate) : new Date();

        //this.uploadedFiles = $obj && $obj.uploadedFiles ? $obj.uploadedFiles : [];

        this.colaboratorId = $obj && $obj.colaboratorId ? $obj.colaboratorId : $obj && $obj.colaborator ? $obj.colaborator.id : null;
        this.absenceTypeId = $obj && $obj.absenceTypeId ? $obj.absenceTypeId : $obj && $obj.absenceType ? $obj.absenceType.id : null;
        //this.userDecisionId = $obj && $obj.userDecisionId ? $obj.userDecisionId : $obj.userDecision ? $obj.userDecision.id : null;

        this.colaborator = $obj && $obj.colaborator ? $obj.colaborator : null;
        this.absenceType = $obj && $obj.absenceType ? new AbsenceTypeModel($obj.absenceType) : null;
        //this.userDecision = $obj && $obj.userDecision ? new User($obj.userDecision) : null;

        this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
        this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : new Date();
    }

    setByForm(form: any) {
        this.startDate = moment(form.startDate).format('YYYY-MM-DD');
        this.endDate = moment(form.endDate).format('YYYY-MM-DD');
        this.duration = form.duration;
        this.status = form.status;
        this.observation = form.observation;
        //this.decisionDate = new Date(form.decisionDate);
        if (form.colaboratorId) this.colaboratorId = form.colaboratorId;
        if (form.absenceTypeId) this.absenceTypeId = form.absenceTypeId;
        //if (form.userDecisionId) this.userDecisionId = form.userDecisionId;
        //this.uploadedFiles = form.uploadedFiles;    

        return this;
    }

    toAPI() {
        return {
            startDate: this.startDate,
            endDate: this.endDate,
            duration: this.duration,
            status: this.status,
            colaboratorId: this.colaboratorId,
            observation: this.observation,
            //decisionDate: this.decisionDate,
            absenceTypeId: this.absenceTypeId,
            //userDecisionId: this.userDecisionId,
            //uploadedFiles: this.uploadedFiles
        };
    }
}
